import React from "react";
import PropTypes from "prop-types";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon } from "MODULES/shared/components";

export default function Cancel({ toggle }) {
  return (
    <DropDownItem onClick={toggle}>
      <Icon name="ban" fixed />
      Remove Line Item
    </DropDownItem>
  );
}

Cancel.propTypes = {
  toggle: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/MarkAllRead/Cancel.jsx